import { render } from "./VpcTab.vue?vue&type=template&id=1e2986b8&scoped=true"
import script from "./VpcTab.vue?vue&type=script&lang=js"
export * from "./VpcTab.vue?vue&type=script&lang=js"

import "./VpcTab.vue?vue&type=style&index=0&id=1e2986b8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2986b8"]])

export default __exports__